import { inject, Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { ProductSplashViewModel } from '@models/api-search.models';
import { ProductEncodeSplashesViewModel } from '@models/api.models';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CampaignTypes } from '@features/product/product.models';

@Pipe({
    name: 'activeSplash',
    standalone: true
})
export class ActiveSplashPipe implements PipeTransform {
    private readonly settingsService: SettingsService = inject(SettingsService);

    /**
     * Tries to find the first hit based on the order of Encodesplashes
     * The order is setup in Umbraco and that is the splash priority
     * @param productSplashes
     * @param type
     * @returns Observable<ProductEncodeSplashesViewModel | null>
     */
    transform(
        productSplashes: ProductSplashViewModel[] | undefined,
        type?: CampaignTypes
    ): Observable<ProductEncodeSplashesViewModel | undefined> {
        if (!productSplashes?.length) {
            return of(undefined);
        }

        return this.settingsService.settings$.pipe(
            take(1),
            map(({ productSettings }) =>
                productSettings?.encodeSplashes.find(encodeSplash =>
                    productSplashes.some(
                        productSplash =>
                            encodeSplash.encodeId === productSplash.id && (type ? productSplash.type === type : true)
                    )
                )
            )
        );
    }
}
